import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import AZ_AZ from 'languages/translations/cw-strings-az-AZ.json';
import DE_DE from 'languages/translations/cw-strings-de-DE.json';
import EN_US from 'languages/translations/cw-strings-en-US.json';
import ES_419 from 'languages/translations/cw-strings-es-419.json';
import ES_ES from 'languages/translations/cw-strings-es-ES.json';
import FR_FR from 'languages/translations/cw-strings-fr-FR.json';
import HI_IN from 'languages/translations/cw-strings-hi-IN.json';
import IT_IT from 'languages/translations/cw-strings-it-IT.json';
import PT_BR from 'languages/translations/cw-strings-pt-BR.json';
import PT_PT from 'languages/translations/cw-strings-pt-PT.json';
import RO_RO from 'languages/translations/cw-strings-ro-RO.json';
import RU_RU from 'languages/translations/cw-strings-ru-RU.json';
import TR_TR from 'languages/translations/cw-strings-tr-TR.json';
import UK_UA from 'languages/translations/cw-strings-uk-UA.json';

import { detectAppLocale } from 'features/locale/mappers';

import LOCALES from 'constants/locales';

const resources = {
  [LOCALES.ENGLISH_US]: { translation: EN_US },
  [LOCALES.SPANISH_ES]: { translation: ES_ES },
  [LOCALES.SPANISH_LATAM]: { translation: ES_419 },
  [LOCALES.PORTUGUESE_BR]: { translation: PT_BR },
  [LOCALES.PORTUGUESE_PT]: { translation: PT_PT },
  [LOCALES.FRENCH_FR]: { translation: FR_FR },
  [LOCALES.RUSSIAN_RU]: { translation: RU_RU },
  [LOCALES.GERMAN_DE]: { translation: DE_DE },
  [LOCALES.HINDI_IN]: { translation: HI_IN },
  [LOCALES.TURKISH_TR]: { translation: TR_TR },
  [LOCALES.AZERBAIJANI_AZ]: { translation: AZ_AZ },
  [LOCALES.ROMANIAN_RO]: { translation: RO_RO },
  [LOCALES.UKRAINIAN]: { translation: UK_UA },
  [LOCALES.ITALIAN_IT]: { translation: IT_IT }
};

i18n.use(initReactI18next).init({
  resources,
  lng: detectAppLocale(),
  fallbackLng: LOCALES.ENGLISH_US,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
    prefix: '{',
    suffix: '}',
    unescapePrefix: '-',
    unescapeSuffix: '',
    prefixEscaped: '\\{',
    suffixEscaped: '\\}',
    maxReplaces: 1000,
    skipOnVariables: true,
    format: (value, format, lng) => {
      if (format === 'uppercase') return value.toUpperCase();
      if (format === 'lowercase') return value.toLowerCase();
      return value;
    }
  },
  returnNull: false,
  debug: false
});

export default i18n;
